import { render, staticRenderFns } from "./OnboardingMobib.vue?vue&type=template&id=afab4eb4&"
import script from "./OnboardingMobib.vue?vue&type=script&lang=js&"
export * from "./OnboardingMobib.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports